import { m } from '../../mithril';
import type { MithrilVNode } from '../../mithril';
import { AppStore } from '../../store/index';
import { userDisplayName } from '../../util/userDisplayName';

export const CSS = {
	container: 'c-UserName',
};

export const UserName = {
	view(userId: string): MithrilVNode {
		if (userId == null) {
			return null;
		}

		const user = AppStore.UserProfile.get(userId);
		if (user == null) {
			return null;
		}

		return m('span', { className: CSS.container }, userDisplayName(user));
	},
};
